import { useState } from 'react'

import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from '@mui/material'
import { match } from 'ts-pattern'

import { verificationCodeSchema } from '../schemas/verification-code-schema'

import { DialogButton } from '~/core/components/dialog-button'
import { GuildApi } from '~/services/fm/guild'
import { BindMobile } from '~/shared/components/bind-mobile'
import { DialogCloseButton } from '~/shared/components/dialog-close-button'
import { VerificationCode } from '~/shared/components/verification-code'

export const IdentityVerificationDialog = (props: {
  open: boolean

  onSubmit: (code: string) => Promise<
    | {
        success: true
      }
    | {
        success: false
        message: string
      }
  >
  onClose: () => void
}) => {
  const mobile = GuildApi.getUserMobile.useQuery()
  const [code, setCode] = useState<string>()
  const [helperText, setHelperText] = useState<string>()
  const [loading, setLoading] = useState(false)

  return (
    <Dialog open={props.open}>
      {match(mobile.data)
        .with(undefined, () => (
          <DialogContent>
            <CircularProgress />
          </DialogContent>
        ))
        .with({ state: 'not_bind' }, () => (
          <>
            <DialogTitle>提示</DialogTitle>
            <DialogContent>
              还没有绑定手机的啦！
              <BindMobile>绑定手机号</BindMobile>
            </DialogContent>
            <DialogActions>
              <DialogButton variant="primary" onClick={props.onClose}>
                确认
              </DialogButton>
            </DialogActions>
          </>
        ))
        .with({ state: 'success' }, ({ mobile }) => (
          <>
            <DialogCloseButton onClick={props.onClose} />
            <DialogTitle>请先验证身份</DialogTitle>
            <DialogContent>
              <Stack spacing={1}>
                <DialogContentText>向您的手机号（{mobile}）发送验证码</DialogContentText>
                <VerificationCode
                  helperText={helperText}
                  slotProps={{
                    input: {
                      value: code,
                      onChange: (e) => setCode(e.target.value),
                    },
                  }}
                />
              </Stack>
            </DialogContent>
            <DialogActions>
              <DialogButton
                variant="primary"
                loading={loading}
                onClick={async () => {
                  setLoading(true)
                  try {
                    const verify = verificationCodeSchema.safeParse(code)
                    if (!verify.success) {
                      setHelperText(verify.error.flatten().formErrors[0])
                      return
                    }
                    const submit = await props.onSubmit(verify.data)
                    if (!submit.success) {
                      setHelperText(submit.message)
                    }
                  } finally {
                    setLoading(false)
                  }
                }}
              >
                提交验证
              </DialogButton>
            </DialogActions>
          </>
        ))
        .exhaustive()}
    </Dialog>
  )
}
